import { useState } from "react"
import { Box, Button, Card, CardContent, CardHeader, Stack, Stepper, Typography } from "@mui/material"
import { If } from "lib/@components/switch.js"
import Iconify from "minimals-template/components/Iconify.js"
import { buildWizardSteps } from "lib/@components/wizard/wizard-steps.js"

export function Wizard({
    title = null,
    about = null,
    subtitle = null,
    icon = null,
    steps = [],
    continueButtonText = "Continue",
    finishButtonText = "Finish",
    backButtonText = "Back",
    backButtonIcon = "mdi:arrow-left",
    showCancel = true,
    cancelCaption = "Cancel",
    onCancel,
    onFinish,
    dataCy = "wizard",
}) {
    const [currentStep, setCurrentStep] = useState(0)
    const lastStep = Math.max(0, steps.length - 1)

    return (
        <Card data-cy={`${dataCy}-wizard`}>
            <CardHeader
                title={
                    <Stack spacing={1}>
                        <Stack direction="row" spacing={1} alignItems="center">
                            <If value={icon}>
                                <Iconify icon={icon} color="primary.main" />
                            </If>
                            <Typography variant="h4">{title}</Typography>
                        </Stack>
                        <If value={about}>
                            <Typography variant="body2" color="text.secondary">
                                {about}
                            </Typography>
                        </If>
                    </Stack>
                }
                subheader={subtitle}
            />

            <CardContent sx={{ pt: 3, overflowY: "auto", overflowX: "hidden" }}>
                <Stepper activeStep={currentStep} orientation="vertical" nonLinear>
                    {buildWizardSteps({
                        steps,
                        currentStep,
                        lastStep,
                        backButtonText,
                        backButtonIcon,
                        continueButtonText,
                        finishButtonText,
                        dataCy,
                        onBack,
                        onSelectStep,
                        onContinue,
                    })}
                </Stepper>
            </CardContent>
            <If truthy={showCancel && typeof onCancel === "function"}>
                <Box sx={{ display: "flex", justifyContent: "flex-start", px: 3, py: 1 }}>
                    <Button
                        startIcon={<Iconify icon="material-symbols:cancel" />}
                        onClick={onCancel}
                        color="primary"
                        data-cy="dialogActionsCancelButton"
                    >
                        {cancelCaption}
                    </Button>
                </Box>
            </If>
        </Card>
    )

    function onSelectStep(index) {
        return function selectStep() {
            if (index > currentStep) return
            setCurrentStep(index)
        }
    }

    function onBack(index) {
        return function back() {
            if (index <= 0) return
            setCurrentStep(index - 1)
        }
    }

    function onContinue(index) {
        return async function goNext() {
            if (index >= lastStep) {
                if (onFinish) {
                    await onFinish()
                }
                return
            }
            setCurrentStep(index + 1)
        }
    }
}
